// src/crypto/aad.ts
// SEC 强约束：所有加密点必须走 buildAAD()，禁直接拼字符串。
// AAD 编码：[ ASCII tag ][ id bytes ][ optional version u64BE ][ user_id ][ crypto_version u8 ]
import { CRYPTO_VERSION } from "./params";
const enc = new TextEncoder();
function concat(...parts) {
    let len = 0;
    for (const p of parts)
        len += p.length;
    const out = new Uint8Array(len);
    let off = 0;
    for (const p of parts) {
        out.set(p, off);
        off += p.length;
    }
    return out;
}
function u8(v) {
    if (v < 0 || v > 0xff)
        throw new RangeError("u8 out of range");
    return new Uint8Array([v]);
}
function u64BE(v) {
    const big = typeof v === "bigint" ? v : BigInt(v);
    const out = new Uint8Array(8);
    const view = new DataView(out.buffer);
    view.setBigUint64(0, big, false); // big-endian
    return out;
}
function uuidBytes(id) {
    if (id.length !== 36)
        throw new Error(`AAD: id must be 36-char UUID, got len=${id.length}`);
    return enc.encode(id);
}
/** 构造 AEAD 所用 additional authenticated data。 */
export function buildAAD(input) {
    const v = u8(CRYPTO_VERSION);
    const uid = uuidBytes(input.user_id);
    switch (input.kind) {
        case "rkw":
            // rkw_aad = b"rkw|v1|" || user_id_utf8(36) || u8(crypto_version)
            return concat(enc.encode("rkw|v1|"), uid, v);
        case "entry":
            // entry_aad = b"entry|v1|" || entry_id || u64BE(version) || user_id || u8(version)
            if (!input.resource_id)
                throw new Error("AAD entry: missing resource_id");
            if (input.version == null)
                throw new Error("AAD entry: missing version");
            return concat(enc.encode("entry|v1|"), uuidBytes(input.resource_id), u64BE(input.version), uid, v);
        case "media":
            if (!input.resource_id)
                throw new Error("AAD media: missing resource_id");
            return concat(enc.encode("media|v1|"), uuidBytes(input.resource_id), uid, v);
        case "thumb":
            if (!input.resource_id)
                throw new Error("AAD thumb: missing resource_id");
            return concat(enc.encode("thumb|v1|"), uuidBytes(input.resource_id), uid, v);
        case "backup":
            if (!input.resource_id)
                throw new Error("AAD backup: missing resource_id");
            if (input.ts_ms == null)
                throw new Error("AAD backup: missing ts_ms");
            return concat(enc.encode("backup|v1|"), uuidBytes(input.resource_id), u64BE(input.ts_ms), uid, v);
        case "draft":
            // PRD v1.1 ②：草稿加密落 IDB。AAD 与 entry 对齐（防互换）。
            if (!input.resource_id)
                throw new Error("AAD draft: missing resource_id");
            return concat(enc.encode("draft|v1|"), uuidBytes(input.resource_id), uid, v);
    }
}
